export default __webpack_public_path__ + "static/media/time-batch-button.241d5faf.png";